import { API } from 'api';
import { useMutation } from 'react-query';

export interface IAgentBulkImportUpload {
  payload: {
    eid?: string;
    file?: File;
    type?: string;
  };
}

const agentBulkImportUpload = (payload: IAgentBulkImportUpload['payload']) => {
  const formData = new FormData();
  formData.append('eid', payload.eid ?? '');
  formData.append('fileData', payload.file ?? '');
  formData.append('type', payload.type ?? '');
  return API.newPost('/api/employer/bulkUpdate/comission/create', formData, {
    'Content-Type': 'multipart/form-data',
  });
};

export const useAgentBulkImportUpload = () => {
  return useMutation(agentBulkImportUpload, {
    onSuccess: (response) => {
      return response.data;
    },
  });
};
